import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CustomInputComponent } from '../../components/input/custom-input/custom-input.component';
import { PrimaryButtonComponent } from '../../components/buttons/primary-button/primary-button.component';
import { IdentityVerificationService } from '../../services/identity-verification/identity-verification.service';
import { ToastService } from '../../services/general/toast.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-phone-verification',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CustomInputComponent,
    PrimaryButtonComponent,
  ],
  templateUrl: './phone-verification.component.html',
  styleUrl: './phone-verification.component.scss'
})
export class PhoneVerificationComponent {
  private _fb = inject(FormBuilder);
  private _router = inject(Router);
  private _identityService = inject(IdentityVerificationService);
  private _toast = inject(ToastService);

  isLoading: boolean = false;
  errorMessage: string = '';

  verificationForm: FormGroup = this._fb.group({
    phoneNumber: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
    code: ['', [Validators.required, Validators.pattern(/^[0-9]{6}$/)]],
  });

  onPhoneNumberInput(value: string) {
    // Only allow numbers
    const numericValue = value.replace(/[^0-9]/g, '');
    if (numericValue.length <= 10) {
      this.verificationForm.patchValue({ phoneNumber: numericValue }, { emitEvent: false });
    }
  }

  onCodeInput(value: string) {
    // Only allow numbers
    const numericValue = value.replace(/[^0-9]/g, '');
    if (numericValue.length <= 6) {
      this.verificationForm.patchValue({ code: numericValue }, { emitEvent: false });
    }
  }

  onSubmit() {
    if (this.verificationForm.valid) {
      this.isLoading = true;
      this.errorMessage = '';
      
      const { phoneNumber, code } = this.verificationForm.value;
      
      this._identityService.validateIdentity({
        mobileNumber: phoneNumber,
        code: code
      }).subscribe({
        next: (response) => {
          this.isLoading = false;
          // Save identity number to localStorage
          if (typeof window !== 'undefined' && response.identityNumber) {
            localStorage.setItem('identityNumber', response.identityNumber);
          }
          // Navigate to photo capture page with id
          this._router.navigate(['/photo-capture'], {
            queryParams: { 
              id: response.id
            }
          });
        },
        error: (error: HttpErrorResponse) => {
          this.isLoading = false;
          
          // Handle 422 errors - display the message from the response
          if (error.status === 422) {
            const errorMessage = error.error?.message || 'Invalid verification code. Please try again.';
            this.errorMessage = errorMessage;
            this._toast.error(errorMessage);
          } else if (error.status === 400) {
            const errorMessage = error.error?.message || 'Bad request. Please try again.';
            this.errorMessage = errorMessage;
            this._toast.error(errorMessage);
          } else {
            this.errorMessage = 'An error occurred. Please try again.';
            this._toast.error('An error occurred. Please try again.');
          }
        }
      });
    } else {
      this.verificationForm.markAllAsTouched();
    }
  }
}
